import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { EnvironmentConfig } from "@rubbl-core";

import { AppModule } from "./app/app.module";

declare var environment: EnvironmentConfig;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
